import { render, staticRenderFns } from "./AuroraWelcomeLeadgen.vue?vue&type=template&id=40c491d8"
import script from "./AuroraWelcomeLeadgen.vue?vue&type=script&lang=js"
export * from "./AuroraWelcomeLeadgen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports